import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'pr-meta-pixel-tracking-code-help',
  imports: [CommonModule],
  templateUrl: './meta-pixel-tracking-code-help.component.html',
  styleUrl: './meta-pixel-tracking-code-help.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MetaPixelTrackingCodeHelpComponent {}
